export function applyFilters(filters: (string | false | 0 | null | undefined)[]) {
  return filters.reduce((acc, currentFilter, i) => `${acc}:${currentFilter}`, '/filters')
}

export function isWebP(url: string) {
  const isConverted = url.includes('filters:format(webp)')
  const isOriginal = /[a-f0-9]+-\d+x\d+\.webp/.test(url)
  return isConverted || isOriginal
}
export function transformSrcSet(srcSet: string[], suffix = '') {
  return srcSet
    .map((src) => {
      const [url, dim] = src.split(' ')
      const imageName = url.split('/').slice(-1)
      return `/static/${dim}--${imageName}${suffix} ${dim}`
    })
    .join(',\n')
}
